import { Component, Input, OnDestroy } from '@angular/core'
import { Router } from '@angular/router'
import { CoreService } from '../../services'
import { MenuItems, MenuService } from '../../configs/menu.service'
import { TranslateService } from '@ngx-translate/core'
import { tap } from 'rxjs/operators'
import { Subscription } from 'rxjs'
import { Emittable, Emitter } from '@ngxs-labs/emitter'
import { PlugplayState } from '../../pages/plug-play/states/plugplay-state.service'

declare let $: any

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent {
  @Input() isShown = false
  @Input() isWizardShown = false
  @Emitter(PlugplayState.setWizardVisibility)
  public readonly setWizardVisibility: Emittable<boolean>
  public lastOpenedSubTree: string
  public menuItems: MenuItems[] = []
  public isMenuReady = false
  private subscriptions = new Subscription()
  constructor(
    private router: Router,
    private core: CoreService,
    private menuService: MenuService,
    private translateService: TranslateService,
  ) {
    this.lastOpenedSubTree = this.core.services.storage.getSync(
      this.core.services.storage.keys.routing.lastOpenedSubTree,
    )
    this.core.services.user.currentUserEmitter.subscribe().then(user => {
      if (user && user.id > 0) {
        this.subscriptions.add(
          this.translateService.onLangChange
            .pipe(
              tap(x => {
                this.menuItems = this.menuService.menuItems(this.core.services.user)
              }),
            )
            .subscribe(),
        )
        this.menuItems = this.menuService.menuItems(this.core.services.user)
        setTimeout(() => {
          if (!this.isMenuReady) {
            this.isMenuReady = true
            this.isShown = true
            setTimeout(() => $('[data-widget="treeview"]').Treeview('init'), 300)
          }
        }, 300)
      } else {
        this.menuItems = []
        setTimeout(() => {
          this.isMenuReady = false
          this.isShown = false
          setTimeout(() => $('[data-widget="treeview"]').Treeview('init'), 300)
        }, 300)
      }
    })
  }

  public setLastOpenedSubTree(item) {
    if (!item.title && this.lastOpenedSubTree) {
      try {
        // @ts-ignore
        document?.getElementById(this.lastOpenedSubTree)?.querySelector('a.nav-link')?.querySelector('i.right')?.click()
      } catch (_) {
        console.error(_)
      }
    }
    this.lastOpenedSubTree = item.title
    this.core.services.storage.set(this.core.services.storage.keys.routing.lastOpenedSubTree, this.lastOpenedSubTree)
  }

  public isActiveLink(item: MenuItems) {
    if (item.link && item.link[0]) {
      return item.link[0] === this.router.url
    } else {
      return false
    }
  }

  public isSubmenuActive(item: MenuItems): boolean {
    return item.sublinks.some(subitem => this.isActiveLink(subitem))
  }
}
